import {
  animation as aK,
  backgroundColor,
  backgroundType,
  bodyTextColor,
  bottomPadding,
  contentPageNameColor,
  contentPageSummaryColor,
  entranceUuid,
  fullWidth,
  hoverEffectUuid,
  listPriceColor,
  marginToBottom,
  marginToLeft,
  marginToRight,
  marginToTop,
  moduleStyle,
  moduleText,
  otherPriceColor,
  productNameColor,
  subtitleColor,
  topPadding,
} from 'src/tools/contentModulesFieldName';

export const moduleStyleFields = [
  [moduleStyle, topPadding],
  [moduleStyle, bottomPadding],
  [moduleStyle, backgroundType],
  [moduleStyle, backgroundColor],
  [moduleStyle, fullWidth],
  [moduleStyle, marginToTop],
  [moduleStyle, marginToBottom],
  [moduleStyle, marginToLeft],
  [moduleStyle, marginToRight],
];

export const animationFields = [
  [aK, entranceUuid],
  [aK, hoverEffectUuid],
];

export const productTextFields = [
  [moduleText, backgroundColor],
  [moduleText, productNameColor],
  [moduleText, bodyTextColor],
  [moduleText, listPriceColor],
  [moduleText, otherPriceColor],
];

export const contentTextFields = [
  [moduleText, backgroundColor],
  [moduleText, subtitleColor],
  [moduleText, contentPageNameColor],
  [moduleText, contentPageSummaryColor],
];

export const CAROUSEL = 'carousel';
export const MOUDLE_STYLE = 'moduleStyle';
export const ANIMATION = 'animation';
export const IMAGES = 'images';
export const PRODUCTS = 'products';
export const TEXT = 'text';
export const CONTENTS = 'contents';
export const GRID = 'grid';
export const POSTER = 'poster';
export const TAB = 'tab';
export const TABSTYLE = 'tabStyle';
export const TAB_LIST = 'tabList';
export const CONTENT = 'content';
export const SUBSCRIPTION = 'subscription';
export const SUBSCRIPTION_STYLE = 'subscriptionStyle';
export const CUSOMER_FIELDS = 'customerFields';
export const TERMS = 'terms';
export const IFRAME = 'iframe';
